module.exports = __webpack_public_path__ + "img/NodeJs.6ad36fa9.png";